/**
 * NO04 - Ordre Search Page
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import clsx from 'clsx';
import LPAppBar from '../../app/components/LPAppBar';
import LPDrawer from '../../app/components/LPDrawer';
import ShiftHome from '../../app/components/ShiftHome';
import Utils from '../../felles/Utils';
import MenuItemTarget from '../../models/MenuItemTarget';
import UISize from '../../models/UISize';
import * as actions from '../../store/actions/index';
import * as actionsNO04 from '../../store/actions/indexNO04';
import { AppState } from '../../store/rootReducer';
import NO04Search from './components/NO04Search';
import NO04List from './components/NO04List';
import { useStyles } from '../../assets/styles/DefaultPageStyle';

export default function NO04Page() {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const screenSize: UISize = useSelector((state: AppState) => state.ui.screenSize);
    const open = screenSize.width > 0 && screenSize.width < 1200 ? false : true;
    const button: boolean = useSelector((state: AppState) => state.ui.isSandwichButtonTurnedOn);
    const n: MenuItemTarget = useSelector((state: AppState) => state.menuItem.menuItemTarget);
    const isResetFormEnabled: boolean = useSelector((state: AppState) => state.NO04Ordre.isResetFormEnabled);

    useEffect(() => {
        return () => {
            if (isResetFormEnabled) {
                dispatch(actionsNO04.NO04ResetForm(true));
            }
        };
    }, [dispatch, isResetFormEnabled]);

    const handlePressedKey = (event: React.KeyboardEvent<HTMLDivElement>) => {
        const { key } = event;
        if ((event.shiftKey && key === 'End') || key === 'F3') {
            event.preventDefault();
            dispatch(actionsNO04.NO04ClearComponentStore());
            dispatch(
                actions.menuItemSetTarget(
                    new MenuItemTarget(
                        n.rootItem,
                        n.item !== '' ? n.item : n.rootItem,
                        '', '', n.tilpasset, n.prodSynlig,
                        n.kodeSynlig, n.labelSynlig, n.menuSynlig,
                        n.hasChildren, n.title
                    )
                )
            );
            dispatch(actions.menuItemSetSelected([n.rootItem, n.item + n.rootItem]));
            navigate(Utils.HOMEPAGE_CONTEXT + '/menu');
        }
    };

    return (
        <div className={classes.root} tabIndex={0} onKeyDown={handlePressedKey}>
            <ShiftHome />
            <CssBaseline />
            <LPDrawer />
            <main
                className={clsx(classes.content, { [classes.contentShift]: button ? true : open })}
                style={{ overflow: 'hidden', height: 'calc(100vh - 45px)', display: 'flex', flexDirection: 'column' }}
            >
                <LPAppBar ismenuvisible={true} />
                <NO04Search />
                <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                    <NO04List />
                </Box>
            </main>
        </div>
    );
}
